/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_MethodInputs */

const en_templates_method = /** @type {(inputs: Templates_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

const he_templates_method = /** @type {(inputs: Templates_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אמצעי`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Templates_MethodInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_method = /** @type {((inputs?: Templates_MethodInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_MethodInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_method(inputs)
	return he_templates_method(inputs)
});